import { Check, Play, Save } from "lucide-react";
import { format } from "date-fns";

export function DraftActionPanel({
  isEdit,
  name,
  previewWithPhone,
  scheduledAt,
  showSchedule,
  saveSuccess,
  canSubmit,
  savePending,
  startPending,
  schedulePending,
  onScheduledAtChange,
  onToggleSchedule,
  onSchedule,
  onSave,
  onStart,
  onValidationError,
}: {
  isEdit: boolean;
  name: string;
  previewWithPhone?: number;
  scheduledAt: string;
  showSchedule: boolean;
  saveSuccess: boolean;
  canSubmit: boolean;
  savePending: boolean;
  startPending: boolean;
  schedulePending: boolean;
  onScheduledAtChange: (value: string) => void;
  onToggleSchedule: () => void;
  onSchedule: () => void;
  onSave: () => void;
  onStart: () => void;
  onValidationError: (message: string) => void;
}) {
  const canRunMutation = !!name && canSubmit && !startPending && !schedulePending;
  const canSave = !!name && canSubmit && !savePending && !schedulePending;

  return (
    <div className="space-y-3">
      {isEdit && showSchedule && (
        <div className="flex flex-wrap items-end gap-3 rounded-lg border bg-slate-50 p-3">
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600">架電予約日時</label>
            <input
              type="datetime-local"
              value={scheduledAt}
              onChange={(e) => onScheduledAtChange(e.target.value)}
              min={format(new Date(), "yyyy-MM-dd'T'HH:mm")}
              className="rounded-lg border px-3 py-2 text-sm"
            />
          </div>
          <button
            onClick={() => {
              if (!scheduledAt) return;
              const dt = new Date(scheduledAt);
              if (dt <= new Date()) {
                onValidationError("過去の日時は指定できません");
                return;
              }
              if (confirm(`${format(dt, "yyyy/MM/dd HH:mm")} に架電開始予約します。よろしいですか？`)) {
                onSchedule();
              }
            }}
            disabled={!scheduledAt || schedulePending || savePending || !canSubmit}
            className="rounded-lg bg-blue-600 px-4 py-2 text-white transition-colors hover:bg-blue-700 disabled:opacity-50"
          >
            {schedulePending ? "保存・予約中..." : "予約確定"}
          </button>
        </div>
      )}
      <div className="flex items-center gap-3">
        <button
          onClick={onSave}
          disabled={!canSave}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
            saveSuccess
              ? "bg-green-600 text-white"
              : "bg-slate-600 text-white hover:bg-slate-700 disabled:opacity-50"
          }`}
        >
          {saveSuccess ? <Check size={18} /> : <Save size={18} />}
          {savePending ? "保存中..." : saveSuccess ? "保存しました" : "保存"}
        </button>
        {isEdit && (
          <>
            <button
              onClick={() => {
                if (confirm(`架電を開始しますか？（対象: ${previewWithPhone || "不明"}件）`)) {
                  onStart();
                }
              }}
              disabled={!canRunMutation}
              className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 transition-colors"
            >
              <Play size={18} />
              {startPending ? "開始中..." : "今すぐ開始"}
            </button>
            <button
              onClick={onToggleSchedule}
              disabled={!canRunMutation}
              className="rounded-lg border px-4 py-2 text-slate-700 transition-colors hover:bg-slate-50 disabled:opacity-50"
            >
              {showSchedule ? "予約入力を閉じる" : "予約開始"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
